// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".YohENotRSAvy68lBe25C .nGkgrgui2reO8vA6fcQs:not([aria-disabled=true]) {\n  color: #eb2f96;\n}\n", "",{"version":3,"sources":["webpack://./../../common/actions.module.less"],"names":[],"mappings":"AAGA;EAEI,cAAA;AAHJ","sourcesContent":["@import '../styles/common-variables';\n@import '../styles/antd-variables';\n\n.menu {\n  .menuDanger:not([aria-disabled=true]) {\n    color: @error-color;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menu": "YohENotRSAvy68lBe25C",
	"menuDanger": "nGkgrgui2reO8vA6fcQs"
};
export default ___CSS_LOADER_EXPORT___;
